import React from 'react';

import { HoverCard, type HoverCardProps } from '../../hover-card/HoverCard';
import {
	SkillHoverCardContent,
	type SkillHoverCardContentProps,
} from '../skill-hover-card-content/SkillHoverCardContent';

export type SkillHoverCardProps = Omit<HoverCardProps, 'content'> & SkillHoverCardContentProps;

export const SkillHoverCard = (props: SkillHoverCardProps): React.JSX.Element => {
	return (
		<HoverCard {...props} content={<SkillHoverCardContent {...props} />}>
			{props.children}
		</HoverCard>
	);
};
